module.exports = __webpack_public_path__ + "static/media/fripulia-r.75fd51f2.png";